import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { defaultLandingPath } from '../utils/divisions';

// Fallback role defaults (used when the server hasn't sent effective_permissions yet).
const ROLE_PERMISSIONS = {
  management: ['dashboard', 'schedule', 'jobs', 'job-detail', 'customers', 'technicians', 'equipment', 'vendors', 'reports', 'daily-summary', 'shop-time', 'settings', 'users', 'form-templates', 'help', 'billing', 'admin'],
  foreman: ['dashboard', 'schedule', 'jobs', 'job-detail', 'shop-time', 'daily-summary', 'help'],
  technician: ['dashboard', 'schedule', 'jobs', 'job-detail', 'shop-time', 'daily-summary', 'help'],
  field_tech: ['field', 'field.calendar', 'help'],
  field_coordinator: ['field', 'field.calendar', 'field.calendar.edit', 'field.assign', 'field.schedule.manage', 'dashboard', 'schedule', 'jobs', 'job-detail', 'customers', 'technicians', 'equipment', 'vendors', 'reports', 'daily-summary', 'help'],
  field_management: ['field', 'field.calendar', 'field.calendar.edit', 'field.assign', 'field.schedule.manage', 'dashboard', 'schedule', 'jobs', 'job-detail', 'customers', 'technicians', 'equipment', 'vendors', 'reports', 'daily-summary', 'help']
};

export default function RoleProtectedRoute({ children, requiredPermission }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="protected-route-loading">
        <div className="text-slate-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ returnTo: `${location.pathname}${location.search}${location.hash}` }} />;
  }

  // Prefer server-computed effective_permissions (respects org role grants + user grants).
  // Fall back to hardcoded role defaults for backwards compatibility.
  const userPermissions = user.effective_permissions && user.effective_permissions.length > 0
    ? user.effective_permissions
    : (ROLE_PERMISSIONS[user.role] || []);

  if (requiredPermission && !userPermissions.includes(requiredPermission)) {
    return <Navigate to={defaultLandingPath(user)} replace />;
  }

  return children;
}
